import React, { useState } from "react";
import {
  Box,
  IconButton,
  Modal,
  Paper,
  Typography,
  Tooltip,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { RiCodeView, RiClipboardLine } from "@remixicon/react";

const modalStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxHeight: "80%",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

interface PlaceDetailsModalCellProps {
  data: Record<string, any>;
  label: string;
}

const PlaceDetailsModalCell: React.FC<PlaceDetailsModalCellProps> = ({
  data,
  label,
}) => {
  const [open, setOpen] = useState(false);

  const sortedData =
  label === "Last Observations"
    ? Object.entries(data)
        .sort(
          ([, dateA], [, dateB]) =>
            new Date(dateB as string).getTime() - new Date(dateA as string).getTime()
        )
    : Object.entries(data);

  const formattedData = JSON.stringify(Object.fromEntries(sortedData), null, 2);

  const entries =
  label === "Last Observations"
    ? Object.entries(data).sort(
        ([, a], [, b]) =>
          new Date(b as string).getTime() - new Date(a as string).getTime()
      )
    : Object.entries(data);

  return (
    <Box display="flex" alignItems="center">
      <Tooltip title={`View ${label}`}>
        <IconButton size="small" onClick={() => setOpen(true)}>
          <RiCodeView size={18} />
        </IconButton>
      </Tooltip>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Paper sx={modalStyle}>
          <Typography variant="h6" gutterBottom>
            {label}
          </Typography>

          <TableContainer>
            <Table size="small">
                <TableHead>
                <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Source</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Value</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {entries.map(([key, value]) => (
                    <TableRow key={key}>
                    <TableCell>{key}</TableCell>
                    <TableCell>
                        {typeof value === "string" && !isNaN(Date.parse(value))
                        ? new Date(value).toLocaleString()
                        : JSON.stringify(value)}
                    </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
          </TableContainer>

          <Box display="flex" justifyContent="space-between" mt={2}>
            <Button
              variant="outlined"
              onClick={() => navigator.clipboard.writeText(formattedData)}
              startIcon={<RiClipboardLine />}
            >
              Copy
            </Button>
            <Button variant="contained" onClick={() => setOpen(false)}>
              Close
            </Button>
          </Box>
        </Paper>
      </Modal>
    </Box>
  );
};

export default PlaceDetailsModalCell;
